import AccountingProvidersList from './AccountingProvidersList';

export default AccountingProvidersList;
